import zod from 'zod';
import { stringToBoolean, stringToList, stringToListOfNumber, zodLimit, zodPage } from './helpers';
import { PlateType } from '../services/central-api/license-plate-recognition';

export const LprLiveEventsSchema = zod.object({
    cameras: stringToList.optional(),
    unitNames: stringToListOfNumber.optional(),
});

export const LprLiveAlertsSchema = zod.object({
    cameras: stringToList.optional(),
    unitNames: stringToListOfNumber.optional(),
});

export const LprSearchSchema = zod.object({
    plate: zod.string().optional(),
    cameras: stringToList.optional(),
    unitNames: stringToListOfNumber.optional(),
    irregularSituation: stringToBoolean,
    isMotorcycle: stringToBoolean,
    beginIn: zod.coerce.number().optional(),
    endIn: zod.coerce.number().optional(),
    type: zod.string().optional(),
});

export const PlatesSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    onlyActive: stringToBoolean,
    type: zod.nativeEnum(PlateType).optional(),
    plate: zod.string().optional(),
});

export const LprReportsSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
});
